import React from "react";
import Box from "@mui/material/Box";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";
import { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { fetchTours, fetchquotelist, fetchdestToursbyDest } from "../api/customerapi";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginLeft: theme.spacing(10),
    marginRight: theme.spacing(10),
    justifyContent: "center",
    backgroundColor: "#f8f8f8",
  },
  icon: {
    align: "center",
    verticalAlign: "middle",
  },
  checkboxalign: {
    alignSelf: "center",
    justifyContent: "center",
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(4),
    width: theme.spacing(60),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  textField2: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(4),
    width: theme.spacing(60),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    //color: "red",
  },
  headertext: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  formgroup: {
    justifyContent: "center",
  },
  textArea: {
    marginLeft: theme.spacing(12),
    marginRight: theme.spacing(14),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  button: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(4),
    width: theme.spacing(25),
    height: theme.spacing(6),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  smallbutton: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(4),
    width: theme.spacing(10),
    height: theme.spacing(4),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  smallbutton2: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(4),
    width: theme.spacing(10),
    height: theme.spacing(4),
  },
  button2: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(4),
    width: theme.spacing(20),
    height: theme.spacing(4),
  },
  button3: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(4),
    width: theme.spacing(25),
    height: theme.spacing(4),
  },
  input: {
    color: "red",
  },
}));

export default function Ladakh() {
  const [value, setValue] = useState(0);
  const classes = useStyles();
  const [quotelist, setquotelist] = useState([]);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const [listtourData, setlisttourData] =useState([{
    tour_name: "",
    tour_description: "",
    tour_city: "",
    tour_destination: "",
    
    }]);

    useEffect(() => {
        loadtours()
        fetchQuotes()
      }, [])

    const loadtours = async () => {
        const data = await fetchdestToursbyDest("Ladakh");
      //console.log(data);
      //const custdatalistfromdb= data.data
      setlisttourData(data.data)
    }
    const fetchQuotes=async()=>{
      const data2 = await fetchquotelist("Ladakh");
      setquotelist(data2.data);
    }
//console.log(listtourData);
  return (
    <div>
      <Box sx={{ width: "100%" }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
            centered
          >
            <Tab label="How to Describe" {...a11yProps(0)} />
            <Tab label="Itineraries and Cost" {...a11yProps(1)} />
            <Tab label="Sightseeing Descriptions" {...a11yProps(2)} />
          </Tabs>
        </Box>
        <TabPanel value={value} index={0}>
          <Typography variant="h6" className={classes.input}>
            About Ladakh:
          </Typography>
          <p>
          Whether you are a solo traveler or you are the one who loves to travel with their flock of peers, every one of us has a list of must-visit places in our lifetime and Ladakh is that one place! Located in the North-Indian territory of Jammu and Kashmir and bounded by the Great Himalayas on one side and the Karakoram range on the other, Ladakh is widely known for its awe-inspiring landscape and unique culture.
          </p>
          <Typography variant="h6" className={classes.input}>
            Main Attractions:
          </Typography>
          <List>
            <ListItem disablePadding>
              <ListItemText>
                <b>Top Places:</b> Leh, Nubra, Pangong
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
                <b>Leh: </b> Magnetic Hill, Leh Palace, Alchi Monastery, Hall Of Fame, Pathar Sahib Gurudwara
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
                <b>Nubra Valley:  </b> Monasteries, Turtuk, Khardungla pass, camping
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
                <b>Pangong:  </b> Chang-la pass, Shey, Hemis & Thiksey monasteries, camping
              </ListItemText>
            </ListItem>
          </List>

          <Typography variant="h6" className={classes.input}>
            Traveller type:
          </Typography>
          <p>Friends (P1), Couples (P2), Family (P3)</p>

          <Typography variant="h6" className={classes.input}>
            Duration:{" "}
          </Typography>
          <p>Min. 3 nights. Max. 6 nights</p>
          <Typography variant="h6" className={classes.input}>
            Documents Required:{" "}
          </Typography>
          <p>
          Adhaar card or VoterID card
          </p>
          
          <Typography variant="h6" className={classes.input}>
            How to reach:{" "}
          </Typography>
          <p>
          Flights to Leh or via cab/bike from Manali

          </p>
          <Typography variant="h6" className={classes.input}>
            Distance between places:
          </Typography>
          <List>
            <ListItem disablePadding>
              <ListItemText>
                <b>Leh - Nubra: </b> 160 KM/ Approx 5 hrs
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
                <b>Leh - Pangong: </b> 230 KM/ Approx 6 hrs
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
                <b>Nubra - Pangong:  </b> 280 KM/ Approx 8 hrs
              </ListItemText>
            </ListItem>      
            
          </List>
          <Typography variant="h6" className={classes.input}>
            Can be clubbed with:{" "}
          </Typography>
          <p>-----------</p>
        </TabPanel>
        <TabPanel value={value} index={1}>
          <Typography variant="h6" className={classes.input}>
            Flight cost: (per person return cost)
          </Typography>
          <List>
            <ListItem disablePadding>
              <ListItemText>
                <b>New Delhi:</b> 6-10k
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
                <b>Mumbai:</b> 14-18k
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
                <b>Bengaluru:</b> 14-18k
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
                <b>Hyderabad:</b> 15-20k
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
                <b>Chennai:</b> 16-20k
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
                <b>Ahmedabad:</b> 10-14k
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
                <b>Kolkata:</b> 15-18k
              </ListItemText>
            </ListItem>

          </List>
          <Typography variant="h6" className={classes.input}>
            Common Itineraries: (Cost and Quote Number)
          </Typography>
          <List>
          {quotelist?.map((quote) => {
                return (
                  <div>
                  <ListItem disablePadding>
                  <ListItemText>
                        <b><a href={"/quotedataentry/"+quote.quote_id} target="_blank" rel="noopener noreferrer">{quote.quote_id} - {quote.quote_identifier}</a></b>
                        </ListItemText>
                      </ListItem>
                  </div>
                );
              })}
          </List>
          <Typography variant="h6" className={classes.input}>
            Total Cost: (per person without flights)
          </Typography>
          <List>
          <ListItem disablePadding>
          <ListItemText>
                <b>3N:</b> 18-24k
              </ListItemText>
          </ListItem>
          <ListItem disablePadding>
          <ListItemText>
                <b>4N:</b> 24-28k
              </ListItemText>
          </ListItem>
          <ListItem disablePadding>
          <ListItemText>
                <b>5N:</b> 28-32k
              </ListItemText>
          </ListItem>
          <ListItem disablePadding>
          <ListItemText>
                <b>6N:</b> 32-38k
              </ListItemText>
          </ListItem>
          </List>
        </TabPanel>
        <TabPanel value={value} index={2}>
          {listtourData.length>1?(
            listtourData.map(tour =>
                <div>
                <p className={classes.input}>{tour.tour_name} -- Start time:({tour.start_time}) || End time:({tour.end_time})</p>
                    
                    {tour.tour_description}
                    <br></br>
                </div>
            )
          ):("")}
        </TabPanel>
      </Box>
    </div>
  );
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
